// src/reduxStore/modules/tenants/types.js

export const SET_TENANT_ENABLE_UPLOAD = 'tenants/SET_TENANT_ENABLE_UPLOAD';
export const SET_USER_EXPLICITLY_ENABLED_UPLOAD = 'tenants/SET_USER_EXPLICITLY_ENABLED_UPLOAD';
export const SET_TENANTS = 'tenants/SET_TENANTS';
export const SET_TENANT_DETAILS = 'tenants/SET_TENANT_DETAILS';
export const SET_TENANT_CONVERSATIONS = 'tenants/SET_TENANT_CONVERSATIONS';
export const SET_CURRENT_TENANT = 'tenants/SET_CURRENT_TENANT';
export const ACTION_SET_SORT_ORDER = 'tenants/ACTION_SET_SORT_ORDER';
export const ACTION_SET_SORT_BY = 'tenants/ACTION_SET_SORT_BY'; 